/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BagorderUpdateBagOrderParam model module.
 * @module model/BagorderUpdateBagOrderParam
 * @version 1.0
 */
class BagorderUpdateBagOrderParam {
    /**
     * Constructs a new <code>BagorderUpdateBagOrderParam</code>.
     * @alias module:model/BagorderUpdateBagOrderParam
     */
    constructor() { 
        
        BagorderUpdateBagOrderParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BagorderUpdateBagOrderParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BagorderUpdateBagOrderParam} obj Optional instance to populate.
     * @return {module:model/BagorderUpdateBagOrderParam} The populated <code>BagorderUpdateBagOrderParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BagorderUpdateBagOrderParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('isDelivered')) {
                obj['isDelivered'] = ApiClient.convertToType(data['isDelivered'], 'Boolean');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
BagorderUpdateBagOrderParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
BagorderUpdateBagOrderParam.prototype['date'] = undefined;

/**
 * @member {Number} id
 */
BagorderUpdateBagOrderParam.prototype['id'] = undefined;

/**
 * @member {Boolean} isDelivered
 */
BagorderUpdateBagOrderParam.prototype['isDelivered'] = undefined;

/**
 * @member {Number} quantity
 */
BagorderUpdateBagOrderParam.prototype['quantity'] = undefined;

/**
 * @member {Number} userId
 */
BagorderUpdateBagOrderParam.prototype['userId'] = undefined;






export default BagorderUpdateBagOrderParam;

